import { TableAction, TableDataSchema } from '@brasshq/ui-kit';
import NameWithAvatar from 'src/sharedComponents/NameWithAvatar';
import { HandlePermission, TFunc } from 'src/types';
import { TeamMember } from 'src/types/entities/administration';

import { TeamMatesDialogType, TeamMatesTableState } from '../types';

import styles from '../components/TeamMatesTable/TeamMatesTable.module.scss';

export function createActions(
  handleStateUpdate: TFunc<Partial<TeamMatesTableState>>,
  handlePermissions: HandlePermission,
): TableAction<TeamMember>[] {
  const isPermitted = handlePermissions('team.manage');
  return [
    {
      label: 'Edit teammate',
      onClick: activeRowData =>
        handleStateUpdate({ showDetailsFlyout: true, activeRowData }),
      handleVisibility: () => !isPermitted,
    },
    {
      label: 'View permissions',
      onClick: activeRowData =>
        handleStateUpdate({ showPrivilegeFlyout: true, activeRowData }),
    },
    {
      label: 'Disable and remove',
      onClick: activeRowData =>
        handleStateUpdate({
          showDialog: true,
          activeRowData,
          dialogType: TeamMatesDialogType.RemoveMember,
        }),
      handleVisibility: activeRowData =>
        !(
          !['business.owner'].includes(activeRowData?.role?.data?.name || '') &&
          isPermitted
        ),
    },
  ];
}

export function createDataSchema(): TableDataSchema<TeamMember>[] {
  return [
    {
      name: (
        <span className={styles.TeamMatesTable_account_name_header}>Name</span>
      ),
      render: row => (
        <NameWithAvatar
          firstname={row?.firstname}
          lastname={row?.lastname}
          isVerified={false}
        />
      ),
    },
    {
      name: 'Email',
      accessor: 'email',
    },
    {
      name: 'Role',
      render: row => row?.role?.data?.display_name || '',
    },
  ];
}
